import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home/Home';
import Contact from './Contact/Contact';
import About from './About/About';
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions/TermsAndConditions';
import CookiesPolicy from './CookiesPolicy/CookiesPolicy';
import Sitemap from './Sitemap/Sitemap';
import Portfolio from './Portfolio/Portfolio';
import ProjectDetail from './Portfolio/ProjectDetail';
import Process from './Process/Process';
import ServiceLanding from './ServiceLanding/ServiceLanding';
import AdminLogin from './Admin/AdminLogin';
import Dashboard from './Admin/Dashboard';
import AdminServices from './Admin/AdminServices';
import AdminSocials from './Admin/AdminSocials';
import AdminInquiries from './Admin/AdminInquiries';
import AdminPortfolio from './Admin/AdminPortfolio';
import AdminAbout from './Admin/AdminAbout';
import AdminContactPage from './Admin/AdminContact';
import AdminPrivacy from './Admin/AdminPrivacy';
import AdminTerms from './Admin/AdminTerms';
import AdminCookies from './Admin/AdminCookies';
import AdminInvoice from './Admin/AdminInvoice';
import ProtectedRoute from './Admin/ProtectedRoute';
import Cursor from './components/Cursor';
import WhatsAppButton from './components/WhatsAppButton';
import { Toaster } from 'react-hot-toast';
import TrafficTracker from './components/TrafficTracker';

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster position="top-right" reverseOrder={false} />
        <TrafficTracker />
        <Cursor />
        <WhatsAppButton />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/cookie-policy" element={<CookiesPolicy />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:id" element={<ProjectDetail />} />
          <Route path="/process" element={<Process />} />

          {/* SEO Service Landing Pages */}
          <Route path="/web-development-vadodara" element={<ServiceLanding />} />
          <Route path="/flutter-app-development" element={<ServiceLanding />} />
          <Route path="/mobile-app-development" element={<ServiceLanding />} />
          <Route path="/ui-ux-design-services" element={<ServiceLanding />} />
          <Route path="/:serviceId" element={<ServiceLanding />} />

          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Protected Admin Routes */}
          <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin/services" element={<ProtectedRoute><AdminServices /></ProtectedRoute>} />
          <Route path="/admin/socials" element={<ProtectedRoute><AdminSocials /></ProtectedRoute>} />
          <Route path="/admin/inquiries" element={<ProtectedRoute><AdminInquiries /></ProtectedRoute>} />
          <Route path="/admin/portfolio" element={<ProtectedRoute><AdminPortfolio /></ProtectedRoute>} />
          <Route path="/admin/about" element={<ProtectedRoute><AdminAbout /></ProtectedRoute>} />
          <Route path="/admin/contact-page" element={<ProtectedRoute><AdminContactPage /></ProtectedRoute>} />
          <Route path="/admin/privacy" element={<ProtectedRoute><AdminPrivacy /></ProtectedRoute>} />
          <Route path="/admin/terms" element={<ProtectedRoute><AdminTerms /></ProtectedRoute>} />
          <Route path="/admin/cookies" element={<ProtectedRoute><AdminCookies /></ProtectedRoute>} />
          <Route path="/admin/invoice" element={<ProtectedRoute><AdminInvoice /></ProtectedRoute>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
